<template>
  <div class="api-test-page-container">
    <a-page-header :title="apiConfig?.name + ' - 接口测试'" @back="handleBack">
      <template #extra>
        <a-button @click="handleBack">返回列表</a-button>
      </template>
    </a-page-header>

    <a-card style="margin-top: 16px">
      <ApiTest 
        :api-config="apiConfig" 
        :base-url="baseUrl"
        @update:base-url="baseUrl = $event"
      />
    </a-card>
  </div>
</template>

<script>
import { ref, onMounted } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { getApiConfig } from '../utils/apiConfigs';
import ApiTest from '../components/ApiTest.vue';

export default {
  name: 'ApiTestPage',
  components: {
    ApiTest
  },
  setup() {
    const router = useRouter();
    const route = useRoute();
    const apiConfig = ref(null);
    const baseUrl = ref('/api');

    const handleBack = () => {
      router.push('/api-management');
    };

    onMounted(() => {
      const apiId = route.params.apiId || route.query.apiId;
      if (apiId) {
        apiConfig.value = getApiConfig(apiId);
      }
      
      // 从 localStorage 加载保存的 baseUrl
      const savedBaseUrl = localStorage.getItem(`api_test_base_url_${apiId}`);
      if (savedBaseUrl) {
        baseUrl.value = savedBaseUrl;
      }
    });

    return {
      apiConfig,
      baseUrl,
      handleBack
    };
  }
};
</script>

<style scoped>
.api-test-page-container {
  padding: 24px;
}
</style>

